import { Promocode } from "../../interfaces/promocode";
import {
  formatPromocodeDate,
  getPromocodeStatus,
  promocodeStatusColor,
  promocodeStatusLabel,
} from "../../utils/promocode";

interface PromocodeListProps {
  promocodes: Promocode[];
  setPromocode: React.Dispatch<React.SetStateAction<Promocode | null>>;
}

export const PromocodeList = ({
  promocodes,
  setPromocode,
}: PromocodeListProps) => {
  return (
    <div className="admin__promo--list">
      <p className="admin__promo--listTitle">Discounts</p>
      <div className="admin__promo--row admin__promo--rowHead">
        <p className="admin__promo--cell">Code ID</p>
        <p className="admin__promo--cell">Period</p>
        <p className="admin__promo--cell">Released</p>
        <p className="admin__promo--cell admin__promo--cellSmall">Used</p>
        <p className="admin__promo--cell admin__promo--cellSmall">Status</p>
      </div>
      <div className="admin__promo--line"></div>
      {promocodes?.map((promocode) => {
        const status = getPromocodeStatus(promocode);
        return (
          <div key={promocode._id}>
            <div
              className="admin__promo--row admin__promo--rowBody"
              onClick={() => {
                setPromocode(promocode);
              }}
            >
              <p className="admin__promo--cell admin__promo--cellCode">
                {promocode.code}
              </p>
              <div className="admin__promo--cell">
                {promocode.withoutTerms ? (
                  <p className="admin__promo--value">Without terms</p>
                ) : (
                  <div>
                    <p className="admin__promo--value">
                      {formatPromocodeDate(promocode.startDate)}
                    </p>
                    <p className="admin__promo--value">
                      {formatPromocodeDate(promocode.endDate)}
                    </p>
                  </div>
                )}
              </div>
              <p className="admin__promo--cell admin__promo--value">
                {promocode.amount || "∞"}
              </p>
              <p className="admin__promo--cell admin__promo--cellSmall admin__promo--value">
                {promocode.used}
              </p>
              <p
                className="admin__promo--cell admin__promo--cellSmall admin__promo--value"
                style={{ color: promocodeStatusColor(status) }}
              >
                {promocodeStatusLabel(status)}
              </p>
            </div>
            <div className="admin__promo--line"></div>
          </div>
        );
      })}
    </div>
  );
};
